import React from "react";
import { Tooltip } from "antd";
import { FileImageOutlined } from "@ant-design/icons";
import "./MarkSampleQCModal.css";

/**
 * Film Thumbnail Component
 * Displays an icon that opens the film image preview modal on click
 */
const FilmThumbnail = ({ onClick }) => (
  <Tooltip title="Click to view petrifilm image">
    <FileImageOutlined
      onClick={onClick}
      className="MarkSampleQCModal__FilmThumbnailIcon"
    />
  </Tooltip>
);

export default FilmThumbnail;
